import landing from './landing.json';
import maps from './maps.json';
import notFound from './notFound.json';
import forgotPassword from './forgotPassword.json';
import forgotPasswordReset from './forgotPasswordReset.json';
import reports from './reports.json';
import login from './login.json';
import signup from './signup.json';
import home from './home.json';
import settings from './settings.json';
import faq from './faq.json';
import myTrees from './myTrees.json';
import site from './site.json';
import admin from './admin.json';
import treePage from './treePage/treePage.json';
import treeInfo from './treePage/treeInfo.json';
import shareMenu from './treePage/shareMenu.json';
import treeActivity from './treePage/treeActivity.json';
import careEntry from './treePage/careEntry.json';
import types from './treePage/types.json';
import forms from './forms.json';
import tables from './tables.json';
import content from './content.json';
import cambridgeLanding from './cambridgeLanding.json';

const translations = {
  en: {
    landing,
    maps,
    notFound,
    forgotPassword,
    forgotPasswordReset,
    reports,
    login,
    signup,
    home,
    settings,
    faq,
    myTrees,
    site,
    admin,
    treePage,
    treeInfo,
    shareMenu,
    treeActivity,
    careEntry,
    types,
    forms,
    tables,
    content,
    cambridgeLanding,
  },
};

export default translations;
